<template>
  <div class="container">
    <header class="jumbotron">
      <h1>Lagleder</h1>
      <div v-if="!content || !content.teams">
        <h3>{{ message }}</h3>
      </div>
      <div v-if="content && content.teams">
        <div>
          ({{content.teams && content.teams.length}} lag)
        </div>
      </div>
    </header>
  <div class="list row">
    <div class="col-md-6">
      <ul class="list-group">
        <li class="list-group-item"
          :class="{ active: index == currentIndex }"
          v-for="(team, index) in content.teams"
          :key="index"
          @click="setActiveTeam(team, index)"
        >
        <div>
          {{ team }} 
        <!-- <a class="badge badge-success float-right"
          :href="`/competition/${selectedCompetition.id}/teamleader/${encodeURIComponent(team)}`"
        > 
          Vis lag
        </a> -->
        <router-link class="badge badge-success float-right"
          :to="{ name: 'teamleader', params: { competition_id: selectedCompetition.id, teamname: encodeURIComponent(team)}}">Vis lag</router-link>
        </div>
        </li>
      </ul>
    </div>
  </div>
  </div>
</template>

<script>
import MyComputed from '../myComputed';
import UserService from '../services/user.service';

export default {
  mixins: [MyComputed],
  name: 'Teams',
  data() {
    return {
      content: '',
      currentTeam: null,
      currentIndex: -1,
      debug: false,
      message: 'Laster inn...'
    };
  },
  mounted() {
    // UserService.getParticipantsBoard(this.$route.params.competition_id).then(
    UserService.getTeamsBoard(this.$route.params.competition_id).then(
      response => {
        // const uniqueSet = new Set();
        // response.data.participants.forEach(item => {
        //   uniqueSet.add(item.participant_team);
        // });
        // response.data.teams = Array.from(uniqueSet);

        this.content = response.data;
      },
      error => {
        if ( error.response.status == 440 ) {
          // this.content="Ingen tilgang... -> login"
          if (error.response && error.response.data.message) {
            this.message = error.response.data.message;
          } else {
            this.message =
              (error.response && error.response.data) ||
              error.message ||
              error.toString();
          }
          setTimeout(() => {
            this.logOut();
          }, 3000)
        } else {
          this.content =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        }
      }
    );
  },
  computed: {
  },
  methods: {
    setActiveTeam(team, index) {
      this.currentTeam = team;
      this.currentIndex = index;
    },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
};
</script>
